module.exports = __webpack_public_path__ + "static/media/OutliersMCQ3_4.e5b437cf.svg";